import { take, call, put, select, takeLatest, delay } from 'redux-saga/effects';
import ActionTypes from './constants';
import request from '../../shared/lib/request';
import uploadRequest from '../../shared/lib/uploadRequest';
import { openSnackBar, closeSnackBar } from '../Root/actions';
import { SLICE_COUNT_OF_CLASSES } from '../../utils/constants';
import moment from 'moment';
import {
  VideoListSuccess,
  videoListFailed,
  filtersFetchSuccess,
  filtersFetchFailed,
  searchSuggestionsSuccess,
  VideoListSuccessWithFilters,
  videoListFailedWithFilters,
  durationSuccess,
  durationFailed,
  requestLiveVideosList,
  videoListCountSuccess,
  videoListSuccessPagination,
  videoAddSuccess,
  filterUpdateList,
  setVideoLoader,
  setLiveSearchVideoLoader,
} from './actions';
import { selectLiveDomain } from './selectors';
import { selectInteractivePublishedClassesDomain } from '../InteractivePublishedClasses/selectors';

// Individual exports for testing
export default function* liveSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(ActionTypes.GET_LIVE_VIDEOS, getLiveVideos);
  yield takeLatest(ActionTypes.UPDATE_VIDEO_LIST, updateVideo);
  yield takeLatest(
    ActionTypes.REQUEST_PAGINATION_LIVE_VIDEO,
    getLiveVideosPagination,
  );
  yield takeLatest(
    ActionTypes.REQUEST_LIVE_FILTER_PARAMS,
    fetchLiveSearchFilter,
  );
  yield takeLatest(
    ActionTypes.LIVE_SEARCH_SUGGESTIONS,
    getLivesearchSuggestions,
  );
  yield takeLatest(
    ActionTypes.REQUEST_lIVE_VIDEO_LIST_WITH_FILTERS,
    searchLiveResults,
  );
  yield takeLatest(
    ActionTypes.VIDEO_LIVE_LIST_WITH_FILTERS_PAGINATION,
    searchLiveResultsPagination,
  );
  yield takeLatest(ActionTypes.LIVE_RE_UPDATE_LIST, getLiveVideos);
  yield takeLatest(ActionTypes.GET_DURATION_DETAILS, getDurationDetails);
  yield takeLatest(ActionTypes.ADD_LIVE_VIDEO_EVENT, addLiveEvent);
  yield takeLatest(ActionTypes.ADD_VIDEO_EVENT, addVideoEvent);
  yield takeLatest(ActionTypes.RE_ENCODE_VIDEO, reEncodeVideo);
  yield takeLatest(ActionTypes.ADD_MULTIPLE_AUDIO_TRACKS, addAudio);
}

export function* getLiveVideos() {
  try {
    let { sortBy, activeTab, interactiveOnly } = yield select(selectLiveDomain);
    yield put(setVideoLoader(true));
    if (sortBy === '') {
      sortBy = 'updatedAt=desc';
    }
    if (activeTab === '') {
      activeTab = 'isHidden=false';
    }
    const interactiveOnlyParam = interactiveOnly ? 'interactive=true&' : '';
    const splitResult = sortBy.split('=');
    let { result, total } = yield call(() =>
      request({
        url: `neouadmin/v1/get-videos?${activeTab}&sortBy=${splitResult[0]}&sortOrder=${splitResult[1]}`,
        method: 'POST',
        data: {
          videoType: 'live',
        },
      }),
    );
    yield put(VideoListSuccess(result));
    yield put(videoListCountSuccess(total));
    yield put(setVideoLoader(false));
  } catch (error) {
    yield put(setVideoLoader(false));
    if (error && error.data && error.data.responseCode === 404) {
      yield put(videoListFailed());
    }
    yield put(videoListFailed());
    yield put(VideoListSuccess([]));
  }
}

export function* updateVideo(action) {
  const { id, load } = action.payload;
  try {
    let { result, total } = yield call(() =>
      request({
        url: `neouadmin/v1/videos?${id}`,
        method: 'PUT',
        data: load,
      }),
    );
    yield put(requestLiveVideosList());
  } catch (error) {
    if (error && error.data && error.data.responseCode === 404) {
      yield put(videoListFailed());
    }
    yield put(videoListFailed());
  }
}

export function* getLiveVideosPagination(action) {
  let offset = action.payload;
  try {
    let { sortBy, activeTab } = yield select(selectLiveDomain);
    if (sortBy === '') {
      sortBy = 'updatedAt=desc';
    }
    const splitResult = sortBy.split('=');
    let { result, total } = yield call(() =>
      request({
        url: `neouadmin/v1/get-videos?${activeTab}&sortBy=${splitResult[0]}&sortOrder=${splitResult[1]}&offset=${offset}&limit=${SLICE_COUNT_OF_CLASSES}`,
        method: 'POST',
        data: {
          videoType: 'live',
        },
      }),
    );
    yield put(videoListSuccessPagination(result));
    yield put(videoListCountSuccess(total));
  } catch (error) {
    if (error && error.data && error.data.responseCode === 404) {
      yield put(VideoListSuccess([]));
    }
    yield put(videoListFailed());
    yield put(VideoListSuccess([]));
  }
}

export function* fetchLiveSearchFilter(action) {
  try {
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/search`,
        method: 'POST',
        data: { videoType: 'live' },
      }),
    );
    const newObj = {};
    result.filterParams.map(itm => {
      newObj[itm.name] = itm;
    });
    const filterObject = Object.keys(newObj);
    filterObject.map(item => {
      if (item !== 'explicitLang') {
        newObj[item].values &&
          newObj[item].values.map((itm, index) => {
            if (item == 'difficulty') {
              itm.isSelected = true;
              itm.mainTitle = item;
              itm.index = index;
            } else {
              itm.isSelected = false;
              itm.mainTitle = item;
              itm.index = index;
            }
          });
      }
    });
    yield put(filtersFetchSuccess(newObj));
  } catch (error) {
    yield put(filtersFetchFailed());
  }
}

export function* getLivesearchSuggestions(searchKeyword) {
  const keyword = searchKeyword.payload;
  let { sortBy, activeTab, interactiveOnly } = yield select(selectLiveDomain);
  const interactiveOnlyParam = interactiveOnly ? '?interactive=true' : '';
  try {
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/search/suggestion/${keyword}`,
        method: 'GET',
      }),
    );
    yield put(searchSuggestionsSuccess(result));
  } catch (error) {
    yield put(filtersFetchFailed());
  }
}

export function* searchLiveResults(action) {
  const values = action.payload;
  const bodyLoad = { videoType: 'live' };
  const objects = Object.keys(action.payload);
  const { filterData } = yield select(selectLiveDomain);
  let durationLength =
    (filterData &&
      filterData.duration &&
      filterData.duration.values &&
      filterData.duration.values.length) ||
    0;
  objects.map(item => {
    if (item === 'keyword') {
      if (values[item].length > 0) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'explicitLang') {
      if (values[item]) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'difficulty') {
      if (values[item].length !== 4 && values[item].length !== 0) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'duration') {
      if (values[item].length !== durationLength) {
        bodyLoad[item] = values[item];
      }
    } else if (
      item !== 'explicitLang' &&
      item !== 'keyword' &&
      item !== 'difficulty' &&
      item !== 'duration' &&
      values[item] &&
      values[item].length > 0
    ) {
      bodyLoad[item] = values[item];
    }
  });
  try {
    yield put(setLiveSearchVideoLoader(true));
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/search`,
        method: 'POST',
        data: bodyLoad,
      }),
    );
    let resultObj = {
      total: result.classes.total,
      result: result.classes.result,
    };
    yield put(videoListCountSuccess(resultObj.total));
    yield put(VideoListSuccessWithFilters(resultObj));
    yield delay(1000);
    yield put(filterUpdateList());
    yield put(setLiveSearchVideoLoader(false));
  } catch (error) {
    yield put(setLiveSearchVideoLoader(false));
    yield put(videoListFailedWithFilters());
  }
}

export function* searchLiveResultsPagination(action) {
  const { values, count } = action.payload;
  const bodyLoad = { videoType: 'live' };
  const objects = Object.keys(values);
  const { filterData } = yield select(selectInteractivePublishedClassesDomain);
  let durationLength =
    (filterData &&
      filterData.duration &&
      filterData.duration.values &&
      filterData.duration.values.length) ||
    0;
  objects.map(item => {
    if (item === 'keyword') {
      if (values[item].length > 0) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'explicitLang') {
      if (values[item]) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'difficulty') {
      if (values[item].length !== 4 && values[item].length !== 0) {
        bodyLoad[item] = values[item];
      }
    } else if (item === 'duration') {
      if (values[item].length !== durationLength && values[item].length !== 0) {
        bodyLoad[item] = values[item];
      }
    } else if (
      item !== 'explicitLang' &&
      item !== 'keyword' &&
      item !== 'difficulty' &&
      item !== 'duration' &&
      values[item] &&
      values[item].length > 0
    ) {
      bodyLoad[item] = values[item];
    }
  });
  try {
    yield put(setLiveSearchVideoLoader(true));
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/search?offset=${count}&limit=${SLICE_COUNT_OF_CLASSES}`,
        method: 'POST',
        data: bodyLoad,
      }),
    );
    let resultObj = {
      total: result.classes.total,
      result: result.classes.result,
    };
    yield put(videoListSuccessPagination(resultObj && resultObj.result));
    yield delay(2000);
    yield put(videoListSuccessPagination([]));
    yield put(videoListCountSuccess(result.classes.total));
  } catch (error) {
    yield put(videoListFailedWithFilters());
    if (error && error.data && error.data.responseCode === 404) {
      yield put(videoListSuccessPagination([]));
      yield put(setLiveSearchVideoLoader(false));
    }
    yield put(videoListFailed());
    yield put(setLiveSearchVideoLoader(false));
  }
}

export function* getDurationDetails() {
  try {
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/duration`,
        method: 'GET',
      }),
    );
    yield put(durationSuccess(result));
  } catch (error) {
    yield put(durationFailed());
  }
}
export function* addLiveEvent(action) {
  try {
    const { result } = yield call(() =>
      request({
        url: `/neouadmin/v1/videos`,
        method: 'POST',
        data: action.payload,
      }),
    );
    yield put(requestLiveVideosList());
    yield put(openSnackBar('Video Added Successfully'));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
  } catch (error) {
    yield put(durationFailed());
    yield put(openSnackBar('Video Adding Failed'));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
  }
}

export function* addVideoEvent(action) {
  let data = action.payload;
  let currenTimeStamp = moment().valueOf();
  let load = {
    CORRELATION_ID: data.CORRELATION_ID,
    url: data.url,
    videoType: 'class',
    permaLink: `/videos/${currenTimeStamp}`,
    isPublished: false,
    fileName: data.url,
  };
  try {
    const { result } = yield call(() =>
      uploadRequest({
        url: data.endPoint,
        method: 'POST',
        data: load,
      }),
    );
    yield put(openSnackBar(`Video Adding Success`));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
    yield put(requestLiveVideosList());
    yield put(videoAddSuccess(true));
  } catch (error) {
    yield put(durationFailed());
    if (error.data && error.data.message) {
      let str = error.data.message;
      if (str.includes('duplicate')) {
        yield put(openSnackBar(`Video URL/Permalink should be unique`));
      } else {
        yield put(openSnackBar(`Video Adding Failed ${error.data.message}`));
      }
    } else {
      yield put(openSnackBar(`Video Adding Failed ${error}`));
    }
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
  }
}

export function* reEncodeVideo(action) {
  let payload = {
    id: action.payload,
  };
  try {
    const { result } = yield call(() =>
      uploadRequest({
        url: `/neou/v1/rencode-video`,
        method: 'POST',
        data: payload,
      }),
    );
    yield put(openSnackBar(`Re-Encoding video is in-progress...`));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
    // yield put(requestVideoList());
  } catch (error) {
    yield put(durationFailed());
    yield put(openSnackBar(`Re-Encoding video Failed ${error}`));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
  }
}

export function* addAudio(action) {
  try {
    const { result } = yield call(() =>
      uploadRequest({
        url: `/neou/v1/add-audio-tracks`,
        method: 'POST',
        data: action.payload,
      }),
    );
    yield put(openSnackBar(`Multiple audio tracks adding is in-progress...`));
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
    // yield put(requestVideoList());
  } catch (error) {
    yield put(durationFailed());
    yield put(
      openSnackBar(
        `Adding audio tracks failed -  ${error.data && error.data.message}`,
      ),
    );
    setTimeout(() => {
      put(closeSnackBar());
    }, 1000);
  }
}
